import { render, staticRenderFns } from "./RenderPage.vue?vue&type=template&id=b3993e10&scoped=true"
import script from "./RenderPage.vue?vue&type=script&lang=js"
export * from "./RenderPage.vue?vue&type=script&lang=js"
import style0 from "./RenderPage.vue?vue&type=style&index=0&id=b3993e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3993e10",
  null
  
)

export default component.exports